import React, { useEffect } from 'react';
// eslint-disable-next-line import-x/no-extraneous-dependencies
import * as ReactGA from 'react-ga';
import { Navigate, Route, Routes } from 'react-router-dom';
import { ErrorsInterceptor } from '../errors-interceptor';
import { AcceptUserInvite } from 'components/accept-user-invite';
import { Account } from 'components/account';
import { Confirm } from 'components/account/confirm';
import { Admin } from 'components/admin';
import { AdminSignin } from 'components/admin-signin';
import { CreateAccount } from 'components/create-account';
import { ForgotPassword } from 'components/forgot-password';
import { PrivateRouteAccountStatus } from 'components/private-route/PrivateAccountStatus';
import { ResetPassword } from 'components/reset-password';
import { ResetPasswordCheck } from 'components/reset-password/reset-password-check';
import { Signin, SigninPassword, SigninSsoError } from 'components/signin';
import { TwoFactor } from 'components/two-factor';
import { Version } from 'components/version';
import { isProduction } from 'config';
import { useGlobalState } from 'store/reducers/reducer';
if (!('process' in window)) {
    window.process = {}; // TODO: Delete?
}
export const AppRoutes = () => {
    const { state } = useGlobalState();
    const isUserLogIn = state.accessToken;
    useEffect(() => {
        if (isProduction) {
            ReactGA.initialize('UA-151415696-1');
            ReactGA.pageview(window.location.pathname + window.location.search);
        }
    });
    return (React.createElement(ErrorsInterceptor, null,
        React.createElement(ResetPasswordCheck, null,
            React.createElement(Routes, null,
                React.createElement(Route, { element: React.createElement(Signin, null), path: "/signin" }),
                React.createElement(Route, { element: React.createElement(SigninPassword, null), path: "/signin-password" }),
                React.createElement(Route, { element: React.createElement(SigninSsoError, null), path: "/signin-error" }),
                React.createElement(Route, { element: React.createElement(AdminSignin, null), path: "/admin-signin" }),
                React.createElement(Route, { element: React.createElement(TwoFactor, null), path: "/verify-2fa" }),
                React.createElement(Route, { element: React.createElement(CreateAccount, null), path: "/create-account" }),
                React.createElement(Route, { element: React.createElement(AcceptUserInvite, null), path: "/join" }),
                React.createElement(Route, { element: React.createElement(ResetPassword, null), path: "/reset-password" }),
                React.createElement(Route, { element: React.createElement(ForgotPassword, null), path: "/forgot-password" }),
                React.createElement(Route, { element: React.createElement(Confirm, null), path: "/account/confirm" }),
                React.createElement(Route, { element: React.createElement(PrivateRouteAccountStatus, null) },
                    React.createElement(Route, { element: isUserLogIn ? (React.createElement(Navigate, { replace: true, to: "/account/jobs" })) : (React.createElement(Navigate, { replace: true, to: "/signin" })), path: "/" }),
                    isUserLogIn && (React.createElement(React.Fragment, null,
                        React.createElement(Route, { element: React.createElement(Account, null), path: "/account/*" }),
                        React.createElement(Route, { element: React.createElement(Admin, null), path: "/admin/*" })))),
                React.createElement(Route, { element: React.createElement(Version, null), path: "/version" }),
                React.createElement(Route, { element: isUserLogIn ? (React.createElement(Navigate, { replace: true, to: "/account/jobs" })) : (React.createElement(Navigate, { replace: true, to: "/signin" })), path: "*" })))));
};
